<template>
  <div>
    <Chart :cdata="cdata" />
  </div>
</template>

<script>
import Chart from './chart.vue'
import timeoutMixin from '@/utils/timeoutMixin'
export default {
  mixins: [timeoutMixin],
  data() {
    let title = {
      offsetCenter: ['0%', '-20%'],
      color: '#fff'
    }
    let detail = {
      valueAnimation: true,
      offsetCenter: ['0%', '30%']
    }
    return {
      cdata: {
        gaugeData1: [
          {
            value: 26,
            name: '室内温度',
            title,
            detail,
            itemStyle: {
              color: '#c46852',
              borderColor: '#c46852'
            }
          }
        ],
        gaugeData2: [
          {
            value: 45,
            name: '室内湿度',
            title,
            detail,
            itemStyle: {
              color: '#5abcc5',
              borderColor: '#5abcc5'
            }
          },
        ],
        gaugeData3: [
          {
            value: 17,
            name: '室内PM2.5',
            title,
            detail,
            itemStyle: {
              color: '#203183',
              borderColor: '#203183'
            }
          },
        ],
        gaugeData4: [
          {
            value: 50,
            name: '室内CO₂',
            title,
            detail,
            itemStyle: {
              color: '#3d6196',
              borderColor: '#3d6196'
            }
          },
        ],
        gaugeData5: [
          {
            value: 32,
            name: '室外温度',
            title,
            detail,
            itemStyle: {
              color: '#c46852',
              borderColor: '#c46852'
            }
          }
        ],
        gaugeData6: [
          {
            value: 30,
            name: '室外湿度',
            title,
            detail,
            itemStyle: {
              color: '#5abcc5',
              borderColor: '#5abcc5'
            }
          },
        ],
        gaugeData7: [
          {
            value: 50,
            name: '室外PM2.5',
            title,
            detail,
            itemStyle: {
              color: '#203183',
              borderColor: '#203183'
            }
          },
        ],
        gaugeData8: [
          {
            value: 70,
            name: '室外CO₂',
            title,
            detail,
            itemStyle: {
              color: '#3d6196',
              borderColor: '#3d6196'
            }
          },
        ],
        category: [
          "2.1",
          "2.2",
          "2.3",
          "2.4",
          "2.5",
          "2.6",
          "2.7",
          "2.8",
          "2.9",
          "2.10",
          "2.11",
          "2.12",
          "2.13",
          "2.14",
          "2.15"
        ],
        lineData: [
          18092,
          20728,
          24045,
          28348,
          32808,
          36097,
          39867,
          44715,
          48444,
          50415,
          56061,
          62677,
          59521,
          67560,
          18092
        ],
        barData: [
          4600,
          5000,
          5500,
          6500,
          7500,
          8500,
          9900,
          12500,
          14000,
          21500,
          23200,
          24450,
          25250,
          33300,
          4600
        ],
        rateData: []
      }
    };
  },
  components: {
    Chart,
  },
  mounted() {
    this.setData();
  },
  methods: {
    // 根据自己的业务情况修改
    setData() {
    },
  }
};
</script>

<style lang="scss" scoped>

</style>